var $e73bf42412feb220$exports = {};
console.log("Did you seriously think this website had javascript;");


//# sourceMappingURL=index.e8f15b74.js.map
